<div>
  <app-header-bar></app-header-bar>
</div>

<div class="integration-main-container">
  <app-integration-sidebar-button class="integration-sidebar"></app-integration-sidebar-button>
  <div class="integration-content">
    <mat-card class="integration-section">
      <h1>System Logs</h1>
      <mat-card-content>
        <div class="logs-toolbar">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Log level filter</mat-label>
            <mat-select [ngModel]="selectedFilter$()" (ngModelChange)="onFilterChange($event)">
              @for (filter of availableFilters; track filter) {
                <mat-option [value]="filter">{{ filter.toUpperCase() }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="lines-field">
            <mat-label>Number of lines</mat-label>
            <input
              matInput
              type="number"
              min="1"
              max="10000"
              [ngModel]="linesNumber$()"
              (ngModelChange)="setLinesNumber($event)"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search in logs</mat-label>
            <input
              matInput
              [ngModel]="searchTerm$()"
              (ngModelChange)="searchTerm$.set($event)"
              placeholder="message, logger, level..."
            />
          </mat-form-field>

          <div class="toolbar-actions">
            <button matButton="filled" (click)="refreshLogs()" [disabled]="isLoading$()">
              <span>Apply</span>
            </button>

            <button
              matButton="outlined"
              (click)="clearFilters()"
              [disabled]="
                isLoading$() ||
                (selectedFilter$() === 'all' && linesNumber$() === 200 && !searchTerm$().trim())
              "
            >
              <mat-icon>clear</mat-icon>
              <span>Clear filters</span>
            </button>
          </div>
        </div>

        @if (errorMessage$()) {
          <p class="error-message">{{ errorMessage$() }}</p>
        }

        <div class="logs-summary-line">
          <span>Total displayed: {{ displayedLogs$().length }}</span>
          @if (isLoading$()) {
            <div class="logs-loading-indicator">
              <mat-spinner diameter="30"></mat-spinner>
            </div>
          }
        </div>

        <div class="logs-table-scroll logs-table-panel">
          <table mat-table [dataSource]="displayedLogs$()">
            <ng-container matColumnDef="logLine">
              <th mat-header-cell *matHeaderCellDef>Log line</th>
              <td mat-cell *matCellDef="let log" class="log-line-cell">
                {{ log.log_line ?? '-' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let log">{{ formatTimestamp(log.timestamp) }}</td>
            </ng-container>

            <ng-container matColumnDef="level">
              <th mat-header-cell *matHeaderCellDef>Level</th>
              <td mat-cell *matCellDef="let log">
                <span
                  class="level-chip"
                  [class.level-debug]="log.level === 'DEBUG'"
                  [class.level-info]="log.level === 'INFO'"
                  [class.level-warning]="log.level === 'WARNING'"
                  [class.level-error]="log.level === 'ERROR'"
                  [class.level-critical]="log.level === 'CRITICAL'"
                >
                  {{ log.level }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="logger">
              <th mat-header-cell *matHeaderCellDef>Logger</th>
              <td mat-cell *matCellDef="let log">{{ log.logger }}</td>
            </ng-container>

            <ng-container matColumnDef="message">
              <th mat-header-cell *matHeaderCellDef>Message</th>
              <td mat-cell *matCellDef="let log" class="message-cell">{{ log.message }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [class.row-debug]="row.level === 'DEBUG'"
              [class.row-info]="row.level === 'INFO'"
              [class.row-warning]="row.level === 'WARNING'"
              [class.row-error]="row.level === 'ERROR'"
              [class.row-critical]="row.level === 'CRITICAL'"
            ></tr>
          </table>
        </div>

        @if (!isLoading$() && displayedLogs$().length === 0) {
          <p class="no-data-info">No logs found for the current filters/search.</p>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
